import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const QnADetailsSkeliton = () => {
  return (
    <>
      <SkeletonTheme baseColor="#202020" highlightColor="#444">
        <div className="container">
          <Skeleton width="100%" className="mt-3 " height={350} />
        </div>

        <div className="container mt-3 my-3">
          <div className="row ">
            <div className="col-md-12">
              <div className="bg-dark card">
                <Skeleton width="25%" className="m-3 " height={20} />
                <Skeleton width="95%" className="mt-0 m-3 " height={200} />
                <Skeleton width="25%" className="mt-5 m-3 " height={20} />

                <div className="row justify-content-evenly ">
                    <div className="col-md-6">
                    <Skeleton width="25%" className="mt-0 m-3 ms-5" height={20} />
                    <Skeleton width="60%" className="mt-0 m-3 ms-5 " height={40} />
                    </div>
                    <div className="col-md-6">
                    <Skeleton width="25%" className="mt-0 m-3 ms-5" height={20} />
                    <Skeleton width="60%" className="mt-0 m-3 ms-5 " height={40} />
                    </div>
                </div>

                <div className="row justify-content-center">
                    <center>
                         <Skeleton width="30%" className="mt-4 m-3 ms-5 " height={40} />
                    </center>
                </div>

              </div>
            </div>
          </div>
        </div>
        
      </SkeletonTheme>
    </>
  );
};

export default QnADetailsSkeliton;
